import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Box, Tab, Tabs } from '@mui/material';

import { PERFORMANCE_TABS } from '../../config';

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function PerformanceTabs() {
  const { pathname } = useLocation();

  const [value, setValue] = useState<number>(0);
  const navigate = useNavigate();

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    navigate(
      PERFORMANCE_TABS.find((item) => {
        return item.index === newValue;
      })?.slug || 'performance_main'
    );
  };

  useEffect(() => {
    const currentTab = PERFORMANCE_TABS.find((item) => pathname.includes(item.slug));

    if (currentTab) {
      setValue(currentTab.index);
    }
  }, [pathname]);

  return (
    <>
      <Box pb={3}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons={false}
          aria-label="Agency profile Tabs"
        >
          {PERFORMANCE_TABS.filter((v) => v.visible).map((item) => (
            <Tab
              key={item.index}
              value={item.index}
              label={item.name}
              disabled={item.disabled}
              {...a11yProps(item.index)}
              sx={{ textTransform: 'uppercase' }}
              onClick={() => {
                if (item.index === value) {
                  navigate(item.slug);
                }
              }}
            />
          ))}
        </Tabs>
      </Box>
    </>
  );
}
